import { render } from "./Contact.vue?vue&type=template&id=e9f76a48"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=e9f76a48&lang=scss"
script.render = render

export default script